import { onDestroy, onMount } from 'svelte';

import { writable } from 'svelte/store';

import type { LottieUID } from '../types';

const lottiesLifecycle = createLottiesLifecycle();

export function initLottieLifecycle(uid: LottieUID) {
  onMount(() => lottiesLifecycle.add(uid));
  onDestroy(() => lottiesLifecycle.remove(uid));
}

function createLottiesLifecycle() {
  const { subscribe, update } = writable(new Map<LottieUID, boolean>());

  return {
    subscribe,
    add: (uid: LottieUID) => update((n) => n.set(uid, true)),
    remove: (uid: LottieUID) =>
      update((n) => {
        n.delete(uid);
        return n;
      }),
  };
}
